var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditPenIcon = function SvgEditPenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "m11.22 4.7-6.842 7.24c-.259.276-.509.818-.559 1.193l-.308 2.7c-.108.975.592 1.641 1.558 1.475l2.684-.459c.375-.066.9-.341 1.158-.625l6.842-7.241c1.183-1.25 1.716-2.675-.125-4.417-1.834-1.725-3.225-1.117-4.409.133Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M10.078 5.908A5.105 5.105 0 0 0 14.62 10.2"
  })));
};
export default SvgEditPenIcon;